import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  Accordion,
  Col,
  Form,
  Row,
  Modal,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Spin } from "antd";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomInput from "../../../CustomControls/CustomInput";
import { post } from "../../../helpers/api_helper";
import {
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import { SVGICON } from "../../../constant/theme";
import moment from "moment";
import {
  POST_GetCustomerProjectAddressDDLList,
  POST_GetReportingsDetailByInwardMaterialID,
  POST_GetReportingsLogoValidityByReportingDate,
  POST_GetReportingsPrintingDownload,
  POST_ReportingsInsert,
} from "../../../helpers/url_helper";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";

const AddReportPrinting = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [tCNoOptions, setTCNoOptions] = useState([]);
  const [inwardNoOptions, setInwardNoOptions] = useState([]);

  const validationSchema = Yup.object().shape({
    InwardMaterialIDEncrypt: Yup.string().required("TC No is required field"),
    ReportingDate: Yup.string().required("Reporting Date is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      ReportingIDEncrypt: "",
      InwardIDEncrypt: AuthUser?.ULRNoGenerateInwardWise
        ? PrimaryIdParam
          ? window.atob(PrimaryIdParam)
          : ""
        : "",
      InwardMaterialIDEncrypt: PrimaryIdParam
        ? window.atob(PrimaryIdParam)
        : "",

      ReportingDate: new Date(),
      PrintSampleSubmittedBy: false,
      PrintAllTestOnSinglePage: false,
      Remarks: "",
      ReportingStatus: 0,
      Address: "",
      ContactPerson: "",
      ProjectName: "",
      CustomerName: "",
      Pincode: "",
      CountryCode: "",
      MobileNo: "",
      CountryName: "",
      StateName: "",
      CityName: "",
      searchAuthorizedSign: "",
      ListAuthorizedSign: [],
      ListTestDetail: [],
      btnSubmitType: 1,
      MinTestingDate: new Date(),
      chkAllTest: false,
      CustomerIDEncrypted: "",
      CustomerProjectIDEncrypted: "",
      InwardModeDetailIDEncrypt: "",
      CustomerProjectAddressIDEncrypted: "",
      IsNABLLogoValidityExpired: false,
      IsILACLogoValidityExpired: false,
      IsILACLogoApplicable: false,
      LogoValidityMessage: "",
      IsNDT: false,
      HidePrintAllTestOnSinglePage: false,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      InwardIDEncrypt,
      ReportingIDEncrypt,
      InwardMaterialIDEncrypt,
      ReportingDate,
      PrintSampleSubmittedBy,
      PrintAllTestOnSinglePage,
      Address,
      ContactPerson,
      ProjectName,
      CustomerName,
      Pincode,
      CountryCode,
      MobileNo,
      CountryName,
      StateName,
      CityName,
      searchAuthorizedSign,
      ListAuthorizedSign,
      ListTestDetail,
      btnSubmitType,
      MinTestingDate,
      chkAllTest,
      CustomerIDEncrypted,
      CustomerProjectIDEncrypted,
      InwardModeDetailIDEncrypt,
      CustomerProjectAddressIDEncrypted,
      IsNABLLogoValidityExpired,
      IsILACLogoValidityExpired,
      IsILACLogoApplicable,
      LogoValidityMessage,
      IsNDT,
      HidePrintAllTestOnSinglePage,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    // if (values?.ListTestDetail?.length == 0) {
    //   warningMessage("Test Details is required");
    //   return;
    // }
    if (
      values?.ListTestDetail?.filter((x) => x.IsSelected == true)?.length == 0
    ) {
      formik.setFieldError("ListTestDetail", "Please select test...");
      formik.setFieldTouched("ListTestDetail", true);
      return;
    }
    if (
      values?.ListAuthorizedSign?.filter((x) => x.IsSelected == true)?.length ==
      0
    ) {
      formik.setFieldError("ListAuthorizedSign", "Authorized Sign is required");
      formik.setFieldTouched("ListAuthorizedSign", true);
      return;
    }

    setIsLoading(true);

    let payload = {
      ReportingIDEncrypt: values?.ReportingIDEncrypt,
      InwardMaterialIDEncrypt: InwardMaterialIDEncrypt,
      InwardIDEncrypt: InwardIDEncrypt,
      ReportingDate: values?.ReportingDate
        ? moment(values?.ReportingDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      PrintSampleSubmittedBy: values?.PrintSampleSubmittedBy,
      PrintAllTestOnSinglePage: values?.PrintAllTestOnSinglePage,
      Remarks: values?.Remarks,
      ReportingStatus: btnSubmitType,
      InwardModeDetailIDEncrypt: values?.InwardModeDetailIDEncrypt,
      CustomerProjectAddressIDEncrypted:
        values?.CustomerProjectAddressIDEncrypted,
      // ReportingAuthorizedSignIDs: Array.from(
      //   values?.ListAuthorizedSign?.filter((e) => e.IsSelected == true),
      //   (x) => x.EmployeeIDEncrypt
      // ).join(","),

      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",

      ListOfReportingsTest_uddt: values?.ListTestDetail?.map((x) => ({
        ReportDetailIDEncrypted: x?.ReportDetailID,
        InwardMaterialTestDetailIDEncrypted:
          x?.InwardMaterialTestDetailIDEncrypt,
        TestMasterIDEncrypted: x?.TestMasterID,
        ReportDetailDate: x?.ReportDetailDate
          ? moment(x?.ReportDetailDate).format("YYYY-MM-DD").replace(/^\-/, "")
          : "",
        Sequence: x?.Sequence,
        PageBreak: x?.PageBreak,
        // PrintingStatus: x?.IsSelected == false ? 1 : 2, // Pending = 1, Printed = 2
        PrintingStatus:
          x?.IsSelected == false
            ? 1
            : AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                AuthUser?.Permissions?.ReportPrintApprovalRequired == true
              ? x?.ApprovalStatus == 1 || x?.PrintingStatus == 2
                ? 2
                : 1
              : 2, // Pending = 1, Printed = 2
        PrintByEncrypted: AuthUser?.ReferenceIDEncrypt
          ? AuthUser?.ReferenceIDEncrypt
          : "0",
        IsDeleted: x?.IsDeleted,
        Horizontal: x?.Horizontal,
      })),

      ListOfReportingAuthorizedSign_uddt: values?.ListAuthorizedSign?.map(
        (x) => ({
          EmployeeIDEncrypt: x?.EmployeeIDEncrypt,
          EmployeeName: x?.EmployeeName,
          Sequence: x?.Sequence,
          IsSelected: x?.IsSelected,
        }),
      ),
    };

    post(POST_ReportingsInsert, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          if (btnSubmitType == 1) {
            successMessage("Record Saved successfully.");
            setTimeout(() => {
              // navigate("/report-printing-list");
              navigate(-1);
            }, 1000);
          } else {
            successMessage("Record Saved successfully.");
            // let payload = {
            //   CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
            //   BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
            //   InwardMaterialIDEncrypted: InwardMaterialIDEncrypt,
            // };
            // post(POST_GetReportingsPrintingDownload, payload)
            //   .then((response) => {
            //     if (response?.IsSuccess) {
            //       successMessage("Record Saved successfully.");
            //       window.open(response?.FilePath);
            //       navigate("/report-printing-list");
            //     } else {
            //       errorMessage(response?.Message);
            //     }
            //     setIsLoading(false);
            //   })
            //   .catch((error) => {
            //     console.log(error);
            //     setIsLoading(false);
            //   });
            setTimeout(() => {
              // navigate("/report-printing-list");
              navigate(-1);
            }, 1000);

            // window.open(
            //   `/print-report/${window.btoa(
            //     InwardMaterialIDEncrypt,
            //   )}/${window.btoa(
            //     btnSubmitType == 2 ? true : false,
            //   )}/${window.btoa(
            //     values?.ListTestDetail?.filter((t) => t.IsSelected == true)
            //       ?.length > 0
            //       ? Array.from(
            //           values?.ListTestDetail?.filter(
            //             (t) => t.IsSelected == true,
            //           ),
            //           (x) => x.TestMasterID,
            //         ).join(",")
            //       : " ",
            //   )}/${window.btoa(IsNDT)}`,
            //   "_blank",
            // );

            const isApprovalGated =
              AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
              AuthUser?.Permissions?.ReportPrintApprovalRequired == true;

            const testsForPrint = values?.ListTestDetail?.filter((t) => {
              if (t.IsSelected != true) return false;
              if (btnSubmitType == 3 && isApprovalGated) {
                return t.ApprovalStatus == 1 || t.PrintingStatus == 2;
              }
              return true;
            });

            window.open(
              `/print-report/${window.btoa(
                InwardMaterialIDEncrypt,
              )}/${window.btoa(
                btnSubmitType == 2 ? true : false,
              )}/${window.btoa(
                testsForPrint?.length > 0
                  ? Array.from(testsForPrint, (x) => x.TestMasterID).join(",")
                  : " ",
              )}/${window.btoa(IsNDT)}`,
              "_blank",
            );
          }
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (InwardMaterialIDEncrypt) {
      getTestDetailsAndProject(InwardMaterialIDEncrypt);
    }
  }, []);

  const handleChangeSearchAuthorizedSign = (e) => {
    formik.setFieldValue("searchAuthorizedSign", e?.target?.value);

    formik.setFieldValue(
      "ListAuthorizedSign",
      ListAuthorizedSign?.map((x) => {
        return {
          ...x,
          display: x.EmployeeName?.toLowerCase().includes(
            e?.target?.value?.toLowerCase(),
          )
            ? true
            : false,
        };
      }),
    );
  };

  const handleChangeTest = (e) => {
    if (AuthUser?.ULRNoGenerateInwardWise) {
      formik.setFieldValue("InwardIDEncrypt", e?.value ?? "");
    } else {
      formik.setFieldValue("InwardMaterialIDEncrypt", e?.value ?? "");
    }
    getTestDetailsAndProject(e?.value);
  };

  const getTestDetailsAndProject = async (InwardMaterialID) => {
    //setIsLoading(true);

    setIsLoading(true);
    await post(POST_GetReportingsDetailByInwardMaterialID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InwardMaterialIDEncrypted: AuthUser?.ULRNoGenerateInwardWise
        ? ""
        : InwardMaterialID,
      InwardIDEncrypted: AuthUser?.ULRNoGenerateInwardWise
        ? InwardMaterialID
        : "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ReportingIDEncrypt",
            response?.ReportingIDEncrypt,
          );
          formik.setFieldValue(
            "ReportingDate",
            response?.ReportingDate
              ? new Date(response?.ReportingDate)
              : new Date(),
          );
          formik.setFieldValue(
            "PrintSampleSubmittedBy",
            response?.PrintSampleSubmittedBy,
          );
          formik.setFieldValue(
            "PrintAllTestOnSinglePage",
            response?.PrintAllTestOnSinglePage,
          );
          formik.setFieldValue("Remarks", response?.Remarks);
          formik.setFieldValue("ReportingStatus", response?.ReportingStatus);

          formik.setFieldValue(
            "IsNABLLogoValidityExpired",
            response?.IsNABLLogoValidityExpired,
          );
          formik.setFieldValue(
            "IsILACLogoValidityExpired",
            response?.IsILACLogoValidityExpired,
          );
          formik.setFieldValue(
            "IsILACLogoApplicable",
            response?.IsILACLogoApplicable,
          );
          formik.setFieldValue(
            "LogoValidityMessage",
            response?.LogoValidityMessage,
          );

          formik.setFieldValue(
            "InwardIDEncrypt",
            response?.CustomerDetails[0]?.InwardIDEncrypted,
          );

          formik.setFieldValue(
            "InwardMaterialIDEncrypt",
            response?.CustomerDetails[0]?.InwardMaterialIDEncrypt,
          );

          formik.setFieldValue(
            "CustomerName",
            response?.CustomerDetails[0]?.CustomerName,
          );
          formik.setFieldValue(
            "ProjectName",
            response?.CustomerDetails[0]?.ProjectName,
          );
          formik.setFieldValue(
            "Address",
            response?.CustomerDetails[0]?.Address,
          );
          formik.setFieldValue(
            "ContactPerson",
            response?.CustomerDetails[0]?.ContactPerson,
          );
          formik.setFieldValue(
            "Pincode",
            response?.CustomerDetails[0]?.Pincode,
          );
          formik.setFieldValue(
            "CountryCode",
            response?.CustomerDetails[0]?.MobileNo
              ? response?.CustomerDetails[0]?.CountryCode
              : "",
          );
          formik.setFieldValue(
            "MobileNo",
            response?.CustomerDetails[0]?.MobileNo,
          );
          formik.setFieldValue(
            "CountryName",
            response?.CustomerDetails[0]?.CountryName,
          );
          formik.setFieldValue(
            "StateName",
            response?.CustomerDetails[0]?.StateName,
          );
          formik.setFieldValue(
            "CityName",
            response?.CustomerDetails[0]?.CityName,
          );
          formik.setFieldValue(
            "MinTestingDate",
            response?.CustomerDetails[0]?.MinTestingDate
              ? new Date(response?.CustomerDetails[0]?.MinTestingDate)
              : new Date(),
          );

          formik.setFieldValue(
            "InwardModeDetailIDEncrypt",
            response?.CustomerDetails[0]?.InwardModeDetailIDEncrypt,
          );

          formik.setFieldValue(
            "CustomerProjectIDEncrypted",
            response?.CustomerDetails[0]?.CustomerProjectIDEncrypted,
          );
          formik.setFieldValue(
            "CustomerIDEncrypted",
            response?.CustomerDetails[0]?.CustomerIDEncrypted,
          );
          formik.setFieldValue(
            "CustomerProjectAddressIDEncrypted",
            response?.CustomerDetails[0]?.CustomerProjectAddressIDEncrypted,
          );
          formik.setFieldValue("IsNDT", response?.CustomerDetails[0]?.IsNDT);
          formik.setFieldValue(
            "HidePrintAllTestOnSinglePage",
            response?.CustomerDetails[0]?.HidePrintAllTestOnSinglePage,
          );

          getProjectAddressDDL(
            response?.CustomerDetails[0]?.CustomerIDEncrypted,
            response?.CustomerDetails[0]?.CustomerProjectIDEncrypted,
            response?.CustomerDetails[0]?.CustomerProjectAddressIDEncrypted,
          );

          setTCNoOptions(
            response?.ListOfTCNumber?.map((item) => ({
              label: item.TCNo,
              value: item.InwardMaterialIDEncrypt,
            })),
          );

          setInwardNoOptions(
            response?.ListOfInwardNumber?.map((item) => ({
              label: item.InwardNo,
              value: item.InwardIDEncrypt,
            })),
          );

          formik.setFieldValue(
            "ListAuthorizedSign",
            response?.ListOfReportingAuthorizedSign?.map((item, indx) => ({
              EmployeeIDEncrypt: item?.EmployeeIDEncrypt,
              EmployeeName: item?.EmployeeName,
              IsSelected: item?.IsSelected,
              Sequence: item?.Sequence == 0 ? indx + 1 : item?.Sequence,
              display: true,
            })),
          );

          // formik.setFieldValue(
          //   "ListTestDetail",
          //   response?.ListOfReportingsTest?.map((x, indx) => ({
          //     InwardMaterialTestDetailIDEncrypt:
          //       x?.InwardMaterialTestDetailIDEncrypt,
          //     TestName: x?.TestName,
          //     Sequence: x?.Sequence == 0 ? indx + 1 : x?.Sequence,
          //     PageBreak: x?.PageBreak,
          //     ReportDetailID: x?.ReportDetailIDEncrypt,
          //     ReportingID: x?.ReportingIDEncrypt,
          //     TestMasterID: x?.TestMasterIDEncrypt,
          //     ReportDetailDate: x?.ReportDetailDate
          //       ? new Date(x?.ReportDetailDate)
          //       : "",
          //     PrintingStatus: x?.PrintingStatus,
          //     PrintBy: x?.PrintBy,
          //     PrintOn: x?.PrintOn,
          //     IsDeleted: false,
          //     IsSelected: x?.PrintingStatus == 1 ? false : true,
          //     Horizontal: x?.Horizontal,
          //   }))
          // );
          /* above code commented to resolve sequence issue when edit case new test having sequence 0*/
          let listOfTestDetails = response?.ListOfReportingsTest?.filter(
            (item) => item.Sequence > 0,
          )?.map((x, indx) => ({
            InwardMaterialTestDetailIDEncrypt:
              x?.InwardMaterialTestDetailIDEncrypt,
            TestName: x?.TestName,
            Sequence: x?.Sequence == 0 ? indx + 1 : x?.Sequence,
            PageBreak: x?.PageBreak,
            ReportDetailID: x?.ReportDetailIDEncrypt,
            ReportingID: x?.ReportingIDEncrypt,
            TestMasterID: x?.TestMasterIDEncrypt,
            ReportDetailDate: x?.ReportDetailDate
              ? new Date(x?.ReportDetailDate)
              : "",
            PrintingStatus: x?.PrintingStatus,
            PrintBy: x?.PrintBy,
            PrintOn: x?.PrintOn,
            IsDeleted: false,
            IsSelected: x?.PrintingStatus == 1 ? false : true,
            Horizontal: x?.Horizontal,
            ApprovalStatus: x?.ApprovalStatus,
          }));

          let iCnt = response?.ListOfReportingsTest?.filter(
            (item) => item.Sequence > 0,
          )?.length;

          response?.ListOfReportingsTest?.filter(
            (item) => item.Sequence == 0,
          )?.map((x, indx) => {
            iCnt = iCnt + 1;
            listOfTestDetails.push({
              InwardMaterialTestDetailIDEncrypt:
                x?.InwardMaterialTestDetailIDEncrypt,
              TestName: x?.TestName,
              Sequence: iCnt,
              PageBreak: x?.PageBreak,
              ReportDetailID: x?.ReportDetailIDEncrypt,
              ReportingID: x?.ReportingIDEncrypt,
              TestMasterID: x?.TestMasterIDEncrypt,
              ReportDetailDate: x?.ReportDetailDate
                ? new Date(x?.ReportDetailDate)
                : "",
              PrintingStatus: x?.PrintingStatus,
              PrintBy: x?.PrintBy,
              PrintOn: x?.PrintOn,
              IsDeleted: false,
              IsSelected: x?.PrintingStatus == 1 ? false : true,
              Horizontal: x?.Horizontal,
              ApprovalStatus: x?.ApprovalStatus,
            });
          });

          formik.setFieldValue("ListTestDetail", listOfTestDetails);

          if (
            listOfTestDetails?.filter((x) => x.IsSelected == false).length == 0
          ) {
            formik.setFieldValue("chkAllTest", true);
          }
        } else {
          //Reset Details
          formik.setFieldValue("InwardMaterialIDEncrypt", "");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const setPageBreak = (i, checkflag) => {
  //   formik.setFieldValue(
  //     "ListTestDetail",
  //     ListTestDetail?.map((x, idx) => {
  //       if (idx == i) {
  //         return {
  //           ...x,
  //           PageBreak: checkflag,
  //         };
  //       } else {
  //         return { ...x };
  //       }
  //     })
  //   );
  // };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragSTParaEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      ListTestDetail,
      result.source.index,
      result.destination.index,
    );

    let newList = [];
    items
      ?.filter((item) => item.IsDeleted === false)
      ?.map((x, idx) => {
        newList.push({
          ...x,
          Sequence: idx + 1,
        });
      });

    items
      ?.filter((item) => item.IsDeleted === true)
      ?.map((x, idx) => {
        newList.push({
          ...x,
          Sequence: 0,
        });
      });
    formik.setFieldValue("ListTestDetail", newList);
  };

  const onDragSTParaEndAuthorizedSign = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      ListAuthorizedSign,
      result.source.index,
      result.destination.index,
    );

    let newList = [];
    items
      ?.filter((item) => item.display === true)
      ?.map((x, idx) => {
        newList.push({
          ...x,
          Sequence: idx + 1,
        });
      });

    items
      ?.filter((item) => item.display === false)
      ?.map((x, idx) => {
        newList.push({
          ...x,
          Sequence: 0,
        });
      });
    formik.setFieldValue("ListAuthorizedSign", newList);
  };

  const [showAddressModal, setShowAddressModal] = useState(false);

  const formikAddress = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitAddress(values, formikHelpers),
    initialValues: {
      projectAddressList: [],
      Address: "",
      Pincode: "",
      CountryCode: "",
      MobileNo: "",
      CountryName: "",
      StateName: "",
      CityName: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { projectAddressList },
  } = formikAddress;

  const handleValidSubmitAddress = (values) => {
    formik.setFieldValue(
      "CustomerProjectAddressIDEncrypted",
      values?.projectAddressList
        ?.filter((x) => x.IsSelected == true)
        ?.map((wd) => wd.CustomerProjectAddressIDEncrypted)[0], // Get the first item
    );

    formik.setFieldValue("Address", values?.Address);
    formik.setFieldValue("Pincode", values?.Pincode);
    formik.setFieldValue(
      "CountryCode",
      values?.MobileNo ? values?.CountryCode : "",
    );
    formik.setFieldValue("MobileNo", values?.MobileNo);
    formik.setFieldValue("CountryName", values?.CountryName);
    formik.setFieldValue("StateName", values?.StateName);
    formik.setFieldValue("CityName", values?.CityName);

    setShowAddressModal(false);
  };

  const getProjectAddressDDL = async (
    customerID,
    projectID,
    ProjectAddressID,
  ) => {
    if (customerID && projectID) {
      setIsLoading(true);
      await post(POST_GetCustomerProjectAddressDDLList, {
        CustomerIDEncrypted: customerID,
        CustomerProjectIDEncrypted: projectID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            formikAddress.setFieldValue(
              `projectAddressList`,
              response?.ProjectAddressDDLList?.map((item) => ({
                Address: item.Address,
                CustomerProjectAddressIDEncrypted:
                  item.CustomerProjectAddressIDEncrypted,
                Pincode: item?.Pincode,
                CountryCode: item?.CountryCode,
                MobileNo: item?.MobileNo,
                CountryName: item?.CountryName,
                StateName: item?.StateName,
                CityName: item?.CityName,
                IsSelected:
                  ProjectAddressID === item?.CustomerProjectAddressIDEncrypted,
              })),
            );
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const handleReportingDate = async (reportingDate) => {
    setIsLoading(true);
    await post(POST_GetReportingsLogoValidityByReportingDate, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      ReportingDate: moment(reportingDate)
        .format("YYYY-MM-DD")
        .replace(/^\-/, ""),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "IsNABLLogoValidityExpired",
            response?.IsNABLLogoValidityExpired,
          );
          formik.setFieldValue(
            "IsILACLogoValidityExpired",
            response?.IsILACLogoValidityExpired,
          );
          formik.setFieldValue(
            "IsILACLogoApplicable",
            response?.IsILACLogoApplicable,
          );
          formik.setFieldValue(
            "LogoValidityMessage",
            response?.LogoValidityMessage,
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Report Printing</h4>
              <div className="d-flex align-items-center">
                <div className="pe-2">
                  <span className="fs-12" style={{ color: "red" }}>
                    {" "}
                    {IsNABLLogoValidityExpired
                      ? " * The validity of the NABL logo has expired. It will not be displayed in the report."
                      : ""}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <span className="fs-12" style={{ color: "red" }}>
                    {IsILACLogoApplicable
                      ? IsILACLogoValidityExpired
                        ? "* The validity of the ILAC logo has expired. It will not be displayed in the report."
                        : ""
                      : ""}
                  </span>{" "}
                  <span className="fs-12" style={{ color: "red" }}>
                    {LogoValidityMessage ? LogoValidityMessage : ""}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  {" "}
                  <Col lg={3}>
                    {AuthUser?.ULRNoGenerateInwardWise ? (
                      <Field
                        label="Inward No"
                        name="InwardIDEncrypt"
                        placeholder={"Select Inward No"}
                        component={CustomSelect}
                        options={inwardNoOptions}
                        required
                        onChange={handleChangeTest}
                        isClearable={false}
                        autoFocus
                      />
                    ) : (
                      <Field
                        label="TC No"
                        name="InwardMaterialIDEncrypt"
                        placeholder={"Select TC No"}
                        component={CustomSelect}
                        options={tCNoOptions}
                        required
                        onChange={handleChangeTest}
                        isClearable={false}
                        autoFocus
                      />
                    )}
                  </Col>
                  <Col lg={3}>
                    <Field
                      label="Reporting Date"
                      name="ReportingDate"
                      placeholder={"Select Reporting Date"}
                      component={CustomFlatpickr}
                      options={{
                        altInput: true,
                        altFormat: "j-M-Y",
                        dateFormat: "d-m-Y",
                        minDate: MinTestingDate,
                        maxDate: new Date(),
                      }}
                      onChange={(e) => {
                        formik.setFieldValue("ReportingDate", e);
                        handleReportingDate(e);
                      }}
                      required
                    />
                  </Col>
                </Row>
                {InwardMaterialIDEncrypt ? (
                  <Row>
                    {" "}
                    <Col lg={3}>
                      <ul>
                        <li>
                          <label className="mb-1">Customer Name :</label>
                          <span className="ms-1">{CustomerName}</span>
                        </li>
                      </ul>
                    </Col>
                    <Col lg={3}>
                      <ul>
                        <li>
                          <label className="mb-1">Project :</label>
                          <span className="ms-1">{ProjectName}</span>
                        </li>
                      </ul>
                    </Col>
                    <Col lg={3}>
                      <ul>
                        <li>
                          <label className="mb-1">
                            <Link
                              to="#"
                              className="icon-box icon-box-md bg-primary-light me-1"
                              title="Change Address"
                              onClick={() => {
                                setShowAddressModal(true);
                              }}
                            >
                              <i className="fa fa-edit"></i>
                            </Link>{" "}
                            <span>Project Address :</span>
                          </label>

                          <span className="ms-1">
                            {Address}
                            <br />
                            {CityName}
                            {CityName && (StateName || CountryName) ? ", " : ""}
                            {StateName}
                            {StateName && CountryName ? ", " : ""}
                            {CountryName}
                            <br />
                            {CountryCode} {""}
                            {MobileNo}
                          </span>
                        </li>
                      </ul>
                    </Col>
                    <Col lg={3}>
                      <ul>
                        <li>
                          <label className="mb-1">Contact Persons :</label>
                          <span className="ms-1">{ContactPerson}</span>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                ) : (
                  ""
                )}
                <hr className="mt-1 mb-1"></hr>
                <Row>
                  <div className="d-flex justify-content-between mb-0">
                    <div className="d-flex mb-0">
                      <label>Test Details</label>
                    </div>
                  </div>
                  <Col lg={8}>
                    <div className="card mb-2" style={{ height: "auto" }}>
                      <div className="card-body p-2">
                        <Row>
                          <Col lg={12}>
                            <div className="row">
                              <DragDropContext onDragEnd={onDragSTParaEnd}>
                                <div className="table-responsive active-projects style-1 shorting">
                                  <div
                                    id="TestDetail-tbl_wrapper"
                                    className="dataTables_wrapper table-responsive no-footer"
                                    style={{
                                      maxHeight: "475px",
                                      overflow: "auto",
                                    }}
                                  >
                                    <table
                                      id="TestDetail-tbl"
                                      className="table dataTable no-footer mb-0"
                                    >
                                      <thead>
                                        <tr>
                                          <th></th>
                                          <th
                                            width="5%"
                                            className="text-center"
                                          >
                                            <input
                                              type="checkbox"
                                              className="form-check-input"
                                              id="chkAllTest"
                                              name="chkAllTest"
                                              checked={formik.values.chkAllTest}
                                              onChange={(e) => {
                                                const isChecked =
                                                  e.target.checked;

                                                // Update the chkAllTest field
                                                formik.setFieldValue(
                                                  "chkAllTest",
                                                  isChecked,
                                                );

                                                // Update all ListTestDetail[].IsSelected values
                                                const updatedListTestDetail =
                                                  formik.values.ListTestDetail.map(
                                                    (item) => ({
                                                      ...item,
                                                      IsSelected: isChecked,
                                                    }),
                                                  );

                                                formik.setFieldValue(
                                                  "ListTestDetail",
                                                  updatedListTestDetail,
                                                );
                                              }}
                                            />
                                          </th>
                                          <th width="5%">Horizontal</th>
                                          <th width="50%">Test Name</th>
                                          <th width="20%">Date</th>
                                          <th width="10%">Sequence</th>
                                          <th
                                            width="10%"
                                            style={{
                                              textAlign: "left",
                                            }}
                                          >
                                            Page Break
                                          </th>
                                        </tr>
                                      </thead>
                                      <Droppable droppableId="droppableTestDetailTable">
                                        {(provided, _) => (
                                          <tbody
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                          >
                                            {ListTestDetail?.length > 0 ? (
                                              ListTestDetail?.map(
                                                (item, indx) => (
                                                  <Draggable
                                                    key={`id_${indx}`}
                                                    draggableId={`id_${indx}`}
                                                    index={indx}
                                                  >
                                                    {(provided, _) => (
                                                      <tr
                                                        role="row"
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        // className="sub-card draggable-handle draggable"
                                                        className={`sub-card draggable-handle draggable ${
                                                          item.IsDeleted ==
                                                            true && "d-none"
                                                        }`}
                                                      >
                                                        <td className="d-items p-1 text-center">
                                                          {SVGICON.Dotes}
                                                        </td>
                                                        <td className="d-items p-1 text-center">
                                                          <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={`chkPrintTest${indx}`}
                                                            name={`chkPrintTest${indx}`}
                                                            checked={
                                                              item.IsSelected
                                                            }
                                                            onChange={(e) => {
                                                              const isChecked =
                                                                e.target
                                                                  .checked;

                                                              // Update the specific ListTestDetail item's IsSelected value
                                                              formik.setFieldValue(
                                                                `ListTestDetail[${indx}].IsSelected`,
                                                                isChecked,
                                                              );

                                                              // Check if any item is unchecked
                                                              const anyUnchecked =
                                                                formik.values.ListTestDetail.some(
                                                                  (
                                                                    itemsub,
                                                                    index,
                                                                  ) =>
                                                                    index ===
                                                                    indx
                                                                      ? !isChecked
                                                                      : !itemsub.IsSelected,
                                                                );

                                                              // Set chkAllTest to false if any item is unchecked
                                                              if (
                                                                anyUnchecked
                                                              ) {
                                                                formik.setFieldValue(
                                                                  "chkAllTest",
                                                                  false,
                                                                );
                                                              } else {
                                                                formik.setFieldValue(
                                                                  "chkAllTest",
                                                                  true,
                                                                );
                                                              }
                                                            }}
                                                          />
                                                        </td>
                                                        <td className="d-items p-1 text-center">
                                                          <div className="d-flex justify-content-between">
                                                            <div className="form-check form-switch me-2 ms-2">
                                                              <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                name={`ListTestDetail.[${indx}].Horizontal`}
                                                                role="switch"
                                                                id={`ListTestDetail.[${indx}].Horizontal`}
                                                                noMarginBottom={
                                                                  true
                                                                }
                                                                checked={
                                                                  item.Horizontal
                                                                }
                                                                onChange={(
                                                                  e,
                                                                ) => {
                                                                  formik.setFieldValue(
                                                                    `ListTestDetail.[${indx}].Horizontal`,
                                                                    e?.target
                                                                      ?.checked,
                                                                  );
                                                                }}
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              ></input>
                                                            </div>
                                                          </div>
                                                        </td>
                                                        <td
                                                          className="d-items p-1 popupOverlay"
                                                          style={{
                                                            minWidth: "110px",
                                                            textAlign: "left",
                                                            cursor: "pointer",
                                                          }}
                                                        >
                                                          <OverlayTrigger
                                                            trigger={[
                                                              "hover",
                                                              "focus",
                                                            ]}
                                                            key={indx}
                                                            responsive={true}
                                                            overlay={
                                                              <Tooltip className="toltip-popover">
                                                                <strong className="p-1">
                                                                  {
                                                                    item.TestName
                                                                  }
                                                                </strong>
                                                              </Tooltip>
                                                            }
                                                          >
                                                            <span>
                                                              {item.TestName}
                                                            </span>
                                                          </OverlayTrigger>
                                                        </td>

                                                        {/* <td
                                                          className="d-items p-1"
                                                          style={{
                                                            minWidth: "100px",
                                                          }}
                                                        >
                                                          {item.TestName}
                                                        </td> */}

                                                        <td
                                                          className="d-items p-1"
                                                          style={{
                                                            minWidth: "100px",
                                                          }}
                                                        >
                                                          <Field
                                                            name={`ListTestDetail[${indx}].ReportDetailDate`}
                                                            placeholder={
                                                              "Select Date"
                                                            }
                                                            component={
                                                              CustomFlatpickr
                                                            }
                                                            options={{
                                                              altInput: true,
                                                              altFormat:
                                                                "j-M-Y",
                                                              dateFormat:
                                                                "d-m-Y",
                                                              minDate:
                                                                MinTestingDate,
                                                            }}
                                                            noMarginBottom={
                                                              true
                                                            }
                                                          />
                                                        </td>
                                                        <td
                                                          className="d-items p-1"
                                                          style={{
                                                            minWidth: "80px",
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          {item.Sequence}
                                                        </td>

                                                        <td className="d-items p-1">
                                                          <div className="d-flex justify-content-between">
                                                            <div className="form-check form-switch me-2 ms-2">
                                                              <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                name={`ListTestDetail.[${indx}].PageBreak`}
                                                                role="switch"
                                                                id={`ListTestDetail.[${indx}].PageBreak`}
                                                                noMarginBottom={
                                                                  true
                                                                }
                                                                checked={
                                                                  item.PageBreak
                                                                }
                                                                onChange={(
                                                                  e,
                                                                ) => {
                                                                  // setPageBreak(
                                                                  //   indx,
                                                                  //   e?.target
                                                                  //     .checked
                                                                  // );
                                                                  formik.setFieldValue(
                                                                    `ListTestDetail.[${indx}].PageBreak`,
                                                                    e?.target
                                                                      ?.checked,
                                                                  );
                                                                }}
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              ></input>
                                                            </div>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </Draggable>
                                                ),
                                              )
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan={8}
                                                  style={{
                                                    textAlign: "left",
                                                  }}
                                                >
                                                  <div>
                                                    {"No Record Found..."}
                                                  </div>
                                                </td>
                                              </tr>
                                            )}
                                            {provided.placeholder}
                                          </tbody>
                                        )}
                                      </Droppable>
                                    </table>
                                  </div>
                                </div>
                                <ErrorMessage
                                  name={"ListTestDetail"}
                                  component="div"
                                  className="invalid-feedback animated fadeInUp"
                                  style={{ display: "block" }}
                                />
                              </DragDropContext>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col lg={4}>
                    <Row>
                      <Col lg={12}>
                        <div className="card mb-2" style={{ height: "auto" }}>
                          <div className="card-body p-2">
                            <Row>
                              <Col lg={12}>
                                <div className="col-xl-12 col-lg-12">
                                  {AuthUser?.LicenseTypeID != 5 && (
                                    <div className="row">
                                      <Col lg={12}>
                                        <div className="d-flex mb-2">
                                          <label>
                                            Print Sample Submitted By
                                            &nbsp;&nbsp;&nbsp;
                                          </label>
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              role="switch"
                                              id="flexSwitchCheckPrintSampleSubmittedBy"
                                              title={
                                                PrintSampleSubmittedBy == true
                                                  ? "Yes"
                                                  : "No"
                                              }
                                              checked={PrintSampleSubmittedBy}
                                              onChange={() => {
                                                formik.setFieldValue(
                                                  "PrintSampleSubmittedBy",
                                                  !PrintSampleSubmittedBy,
                                                );
                                              }}
                                              style={{ cursor: "pointer" }}
                                            ></input>
                                          </div>
                                        </div>
                                      </Col>
                                    </div>
                                  )}
                                  {AuthUser?.ULRNoGenerateInwardWise === false
                                    ? HidePrintAllTestOnSinglePage != true && (
                                        <div className="row">
                                          <Col lg={12}>
                                            <div className="d-flex mb-2">
                                              <label>
                                                Print All Test In Singal Page
                                                &nbsp;&nbsp;&nbsp;
                                              </label>
                                              <div className="form-check form-switch">
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  role="switch"
                                                  id="flexSwitchCheckPrintAllTestInSingalPage"
                                                  title={
                                                    PrintAllTestOnSinglePage ==
                                                    true
                                                      ? "Yes"
                                                      : "No"
                                                  }
                                                  checked={
                                                    PrintAllTestOnSinglePage
                                                  }
                                                  onChange={() => {
                                                    formik.setFieldValue(
                                                      "PrintAllTestOnSinglePage",
                                                      !PrintAllTestOnSinglePage,
                                                    );
                                                  }}
                                                  style={{ cursor: "pointer" }}
                                                ></input>
                                              </div>
                                            </div>
                                          </Col>{" "}
                                        </div>
                                      )
                                    : ""}
                                  <div className="row">
                                    <Col lg={12}>
                                      <Field
                                        label="Remarks"
                                        name="Remarks"
                                        placeholder={"Enter Remarks"}
                                        component={CustomTextArea}
                                        rows={5}
                                        maxLength={500}
                                      />
                                    </Col>
                                  </div>
                                  <div className="row">
                                    <Col lg={12}>
                                      <label className="mb-1">
                                        Authorized Sign
                                      </label>
                                      <div className="card mb-0 w-100">
                                        <DragDropContext
                                          onDragEnd={
                                            onDragSTParaEndAuthorizedSign
                                          }
                                        >
                                          <div className="card-header p-0">
                                            <input
                                              type="text"
                                              name="searchAuthorizedSign"
                                              placeholder={"Search here..."}
                                              className="form-control form-control-sm"
                                              value={searchAuthorizedSign}
                                              onChange={
                                                handleChangeSearchAuthorizedSign
                                              }
                                              style={{
                                                borderBottomLeftRadius: "0",
                                                borderBottomRightRadius: "0",
                                              }}
                                            ></input>
                                          </div>

                                          <div
                                            className="card-body p-0 table-responsive"
                                            style={{
                                              maxHeight: "145px",
                                              overflow: "auto",
                                            }}
                                          >
                                            <table className="table table-hover header-border no-footer">
                                              <Droppable droppableId="droppableAuthorizedSignTable">
                                                {(provided, _) => (
                                                  <tbody
                                                    {...provided.droppableProps}
                                                    ref={provided.innerRef}
                                                  >
                                                    {ListAuthorizedSign?.filter(
                                                      (x) => x.display == true,
                                                    )?.length > 0 ? (
                                                      ListAuthorizedSign?.map(
                                                        (item, indx) => (
                                                          <Draggable
                                                            key={`id_${indx}`}
                                                            draggableId={`id_${indx}`}
                                                            index={indx}
                                                          >
                                                            {(provided, _) => (
                                                              <tr
                                                                style={{
                                                                  display:
                                                                    item?.display ==
                                                                    true
                                                                      ? ""
                                                                      : "none",
                                                                }}
                                                                key={indx}
                                                                role="row"
                                                                ref={
                                                                  provided.innerRef
                                                                }
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                className={`sub-card draggable-handle draggable ${
                                                                  item.display ==
                                                                    false &&
                                                                  "d-none"
                                                                }`}
                                                              >
                                                                <td className="d-items p-1 text-center">
                                                                  {
                                                                    SVGICON.Dotes
                                                                  }
                                                                </td>
                                                                <td className="d-items p-1 text-center">
                                                                  <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    id={`chkAuthorizedSign${indx}`}
                                                                    name={`chkAuthorizedSign${indx}`}
                                                                    checked={
                                                                      item.IsSelected
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) => {
                                                                      formik.setFieldValue(
                                                                        `ListAuthorizedSign[${indx}].IsSelected`,
                                                                        e.target
                                                                          .checked,
                                                                      );
                                                                    }}
                                                                  />
                                                                </td>
                                                                <td
                                                                  style={{
                                                                    textAlign:
                                                                      "left",
                                                                    padding:
                                                                      "0.5rem",
                                                                    width:
                                                                      "85%",
                                                                  }}
                                                                >
                                                                  {
                                                                    item.EmployeeName
                                                                  }
                                                                </td>
                                                              </tr>
                                                            )}
                                                          </Draggable>
                                                        ),
                                                      )
                                                    ) : (
                                                      <tr>
                                                        <td
                                                          colSpan={2}
                                                          style={{
                                                            textAlign: "center",
                                                          }}
                                                        >
                                                          <div>
                                                            {"No options"}
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    )}
                                                    {provided.placeholder}
                                                  </tbody>
                                                )}
                                              </Droppable>
                                            </table>
                                          </div>
                                        </DragDropContext>
                                      </div>
                                    </Col>
                                    <ErrorMessage
                                      name={"ListAuthorizedSign"}
                                      component="div"
                                      className="invalid-feedback animated fadeInUp"
                                      style={{ display: "block" }}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {/* <hr className="mt-1"></hr> */}

                <div className="stickyBottomButtons">
                  <hr className="mt-0 mb-2"></hr>
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => {
                      formik.setFieldValue("btnSubmitType", 1);
                    }}
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => {
                      formik.setFieldValue("btnSubmitType", 2);
                    }}
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit & Draft
                    Print
                  </button>
                  {AuthUser?.Permissions?.ApprovalWorkflow != 1 ||
                  AuthUser?.Permissions?.ReportPrintApprovalRequired == false ||
                  (AuthUser?.Permissions?.ApprovalWorkflow == 1 &&
                    AuthUser?.Permissions?.ReportPrintApprovalRequired ==
                      true &&
                    ReportingIDEncrypt &&
                    ListTestDetail?.filter(
                      (x) => x.ApprovalStatus == 1 || x.PrintingStatus == 2,
                    ).length > 0) ? (
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm me-2"
                      onClick={() => {
                        formik.setFieldValue("btnSubmitType", 3);
                      }}
                    >
                      <i className="fa-solid fa-floppy-disk"></i> Submit & Print
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-primary btn-sm me-2"
                      disabled={true}
                    >
                      <i className="fa-solid fa-floppy-disk"></i> Submit & Print
                    </button>
                  )}

                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </div>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
        <Modal
          className="fade"
          show={showAddressModal}
          onHide={setShowAddressModal}
          size="lg"
        >
          <FormikProvider value={formikAddress}>
            <Form onSubmit={formikAddress.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Project Address</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowAddressModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="table-responsive active-projects style-1 shorting mb-0">
                      <div
                        id="AddressDetail-tbl_wrapper"
                        className="dataTables_wrapper table-responsive no-footer"
                      >
                        <table
                          id="AddressDetail-tbl"
                          className="table table-bordered no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="5%"></th>
                              <th width="95%" style={{ textAlign: "left" }}>
                                Address
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {projectAddressList?.length > 0 ? (
                              projectAddressList?.map((item, indx) => (
                                <tr key={indx}>
                                  <td
                                    style={{
                                      textAlign: "center",
                                      padding: "0.5rem",
                                      width: "5%",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkAddress${indx}`}
                                      name={`chkAddress${indx}`}
                                      checked={item?.IsSelected}
                                      onChange={(e) => {
                                        formikAddress.setFieldValue(
                                          "projectAddressList",
                                          projectAddressList?.map((x, idx) => {
                                            if (idx == indx) {
                                              return {
                                                ...x,
                                                IsSelected: true,
                                              };
                                            } else {
                                              return {
                                                ...x,
                                                IsSelected: false,
                                              };
                                            }
                                          }),
                                        );
                                        formikAddress.setFieldValue(
                                          "Address",
                                          item?.Address,
                                        );
                                        formikAddress.setFieldValue(
                                          "Pincode",
                                          item?.Pincode,
                                        );
                                        formikAddress.setFieldValue(
                                          "CountryCode",
                                          item?.CountryCode,
                                        );
                                        formikAddress.setFieldValue(
                                          "MobileNo",
                                          item?.MobileNo,
                                        );
                                        formikAddress.setFieldValue(
                                          "CountryName",
                                          item?.CountryName,
                                        );
                                        formikAddress.setFieldValue(
                                          "StateName",
                                          item?.StateName,
                                        );
                                        formikAddress.setFieldValue(
                                          "CityName",
                                          item?.CityName,
                                        );
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      padding: "0.5rem",
                                      width: "95%",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {item.Address}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={2} style={{ textAlign: "left" }}>
                                  <div>{"No record found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button type="submit" variant="primary btn-sm">
                  Submit
                </Button>

                <Button
                  variant="danger btn-sm"
                  onClick={() => {
                    setShowAddressModal(false);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Modal>
      </div>
    </div>
  );
};

export default AddReportPrinting;
